import React, { useState } from 'react';
import styled from 'styled-components';
import Tippy from '@tippyjs/react';
import { AddInfo, ChevronDown, ChevronUp } from '../Icons';
import { Utils } from 'autenti-components';
import { isDocsApp } from '../../helpers/hosts';
import { NavLink } from 'react-router-dom';
const Container = styled.div `
  position: static;
  ${({ mode }) => mode === 'DEFAULT' && `max-width: 250px;`}
  ${({ mode }) => mode === 'COLLAPSED_SUB_ELEMENT' &&
    `
    padding-left: 15px;
    padding-right: 15px;
  `}
  .styled-nav-link {
    color: #fff;
    font-weight: bold;
    text-decoration: underline;
  }
`;
const SectionTitle = styled.div `
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  font-style: normal;
  font-weight: ${({ mode }) => mode === 'COLLAPSED_SUB_ELEMENT' ? 'normal' : 'bold'};
  font-size: ${({ mode }) => mode === 'COLLAPSED_SUB_ELEMENT' ? '14px' : '18px'};
  line-height: ${({ mode }) => mode === 'COLLAPSED_SUB_ELEMENT' ? '20px' : '24px'};
  color: #0d1e2e;

  ${({ mode }) => mode === 'DEFAULT' && `margin: 20px;`};
  ${({ mode }) => mode === 'COLLAPSED_HEADER' && `margin: 16px 15px;`};
  ${({ mode }) => mode === 'COLLAPSED_SUB_ELEMENT' && `margin-bottom: 16px;`};

  .tooltip-icon {
    margin-left: 3px;
  }

  .chevron-icon {
    transform: scale(0.7);
  }
`;
const TooltipContent = styled.span `
  color: #ffffff;
  font-size: 12px;
  letter-spacing: 0;
  line-height: 18px;
`;
const StyledA = styled.a `
  color: #fff;
  font-weight: bold;
  text-decoration: underline;
`;
const CollapsedPanel = ({ mode, children, initialChildrenVisible = false, label, tooltipText, toggleExpandableState, expandableName, expandableState, isExpandableByParent, expandablePath, }) => {
    const [childrenVisible, setChildrenVisible] = useState(initialChildrenVisible);
    expandablePath = expandablePath ? expandablePath : '#';
    const SectionTitleComponent = (React.createElement(SectionTitle, { mode: mode, onClick: () => {
            isExpandableByParent
                ? toggleExpandableState(expandableName)
                : setChildrenVisible(!childrenVisible);
        } },
        React.createElement("div", null,
            label,
            tooltipText && (React.createElement(Tippy, { content: React.createElement(TooltipContent, null, tooltipText), placement: "top-end" },
                React.createElement("span", { className: "tooltip-icon" },
                    React.createElement(AddInfo, { width: 12, height: 12 }))))),
        mode !== 'DEFAULT' && (React.createElement("div", { className: 'chevron-icon' }, (isExpandableByParent
            ? expandableState === expandableName
            : !isExpandableByParent && childrenVisible) ? (!isExpandableByParent && React.createElement(ChevronUp, null)) : (React.createElement(ChevronDown, null))))));
    return (React.createElement(Container, { mode: mode },
        isDocsApp() && isExpandableByParent && (React.createElement(NavLink, { className: 'styled-nav-link', to: expandablePath }, SectionTitleComponent)),
        !isDocsApp() && isExpandableByParent && (React.createElement(StyledA, { href: `${Utils.getUrlTo('docs')}${expandablePath}` }, SectionTitleComponent)),
        !isExpandableByParent && (React.createElement(StyledA, { href: "#" },
            " ",
            SectionTitleComponent,
            " ")),
        (isExpandableByParent
            ? expandableState === expandableName
            : !isExpandableByParent && childrenVisible) &&
            mode !== 'DEFAULT' &&
            children,
        mode === 'DEFAULT' && children));
};
export default CollapsedPanel;
